import React, { FC } from "react";

import { KpiTermType } from "~/domains";

import { TextField } from "~/ui";

type PropsType = {
  className?: string;
  kpiTerm: Pick<KpiTermType, "title" | "fromDate" | "toDate">;
};

export const KpiTermHeader: FC<PropsType> = ({
  className = "",
  kpiTerm,
}: PropsType) => {
  return (
    <div className={`grid miniTablet:grid-cols-2 gap-4 ${className}`}>
      <TextField
        type="text"
        name="kpiTitle"
        disabled
        defaultValue={kpiTerm.title}
        className="text-center"
      />
      <TextField
        type="text"
        name="kpiTermRange"
        disabled
        defaultValue={`${kpiTerm.fromDate} ~ ${kpiTerm.toDate}`}
        className="text-center"
      />
    </div>
  );
};
